















import { VaeSurveillanceType } from "@/models";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { BBadge } from "bootstrap-vue";

@Component({ components: { BBadge } })
export default class VaePadge extends Vue {
  @Prop() readonly surveillanceType!: VaeSurveillanceType;

  get show() {
    const type = this.surveillanceType ?? VaeSurveillanceType.None;
    return type != VaeSurveillanceType.None;
  }

  get badgeVariant() {
    switch (this.surveillanceType) {
      case VaeSurveillanceType.CriteriaMet:
        return "danger";
      case VaeSurveillanceType.VaeDay2:
        return "orange";
      case VaeSurveillanceType.VaeDay1:
        return "warning";
      default:
        return null;
    }
  }
}
